module.exports = __webpack_public_path__ + "media/images/features/modification/table-price-50a8814efc5c9e19a46c8fb1912d461c.svg";